import { useContext } from "react"
import { useReservation } from "../../../ReservationHooks/useReservation"
import { AdminContext } from "~/contexts/AdminContext"
import { EditReservationContext } from "~/contexts/admin/EditReservationContext"
type Props = {
  total_owed: string
}
export const useTakePaymentButton = (props: Props) => {
  const { total_owed } = props
  const { selectedReservation, showPaymentModal } = useContext(AdminContext)
  const { onUpdateReservation, refUpdateReservationForm } = useContext(EditReservationContext)
  const { data: reservationData } = useReservation({
    reservationId: selectedReservation?.id,
  })
  
  const handleAcceptPayment = async () => {
    if (!total_owed) return
    const formRef = refUpdateReservationForm
    if (formRef.current) {
      const form = formRef.current
      new Promise((resolve) => {
        const onSubmitWrapper = async (event: any) => {
          const res = await onUpdateReservation(event, true)
          form.removeEventListener("submit", onSubmitWrapper)
          resolve(res)
        }
        form.addEventListener("submit", onSubmitWrapper)
      })
      form.dispatchEvent(new Event("submit", { cancelable: true }))
      const reservation = reservationData?.reservation
      const owedInCents = reservation?.total_owed_in_cents
        ? reservation.total_owed_in_cents
        : parseFloat(total_owed) * 100.0
      showPaymentModal(owedInCents, { reservation })
    }
  }
  return { handleAcceptPayment }
}